const CRASH_BUFFER_KEY = "hs_crash_buffer_v1";

function safeToString(v) {
  try {
    if (typeof v === "string") return v;
    return JSON.stringify(v);
  } catch {
    try {
      return String(v);
    } catch {
      return "[unstringifiable]";
    }
  }
}

function readCrashBuffer() {
  try {
    const raw = window.sessionStorage.getItem(CRASH_BUFFER_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeCrashBuffer(items) {
  try {
    window.sessionStorage.setItem(CRASH_BUFFER_KEY, JSON.stringify(items.slice(-50)));
  } catch {
    /* ignore */
  }
}

export function pushCrashLog(event, details) {
  if (typeof window === "undefined") return;

  const payload = {
    type: "hs_crashlog",
    event: String(event || "unknown"),
    at: new Date().toISOString(),
    href: safeToString(window.location?.href),
    pathname: safeToString(window.location?.pathname),
    userAgent: safeToString(window.navigator?.userAgent),
    details: details ?? null,
  };

  // Keep a local breadcrumb so we can inspect after reload.
  const buf = readCrashBuffer();
  buf.push(payload);
  writeCrashBuffer(buf);

  // Console for browser debugging.
  // eslint-disable-next-line no-console
  console.error("[HealthSprint crashlog]", payload);

  // Forward to React Native wrapper if present.
  const rn = window.ReactNativeWebView;
  if (rn && typeof rn.postMessage === "function") {
    try {
      rn.postMessage(JSON.stringify(payload));
    } catch {
      // ignore
    }
  }
}

export function initCrashLogger() {
  if (typeof window === "undefined") return;

  if (window.__hsCrashLoggerInstalled) return;
  window.__hsCrashLoggerInstalled = true;

  // Report the last few logs on startup (helps with "reverts back" loops).
  try {
    const buf = readCrashBuffer();
    if (buf.length) {
      const tail = buf.slice(-10);
      pushCrashLog("startup_recent_logs", { count: tail.length, tail });
    }
  } catch {
    /* ignore */
  }

  window.addEventListener("error", (ev) => {
    const err = ev?.error;
    pushCrashLog("window_error", {
      message: ev?.message,
      filename: ev?.filename,
      lineno: ev?.lineno,
      colno: ev?.colno,
      errorName: err?.name,
      errorMessage: err?.message,
      stack: err?.stack,
    });
  });

  window.addEventListener("unhandledrejection", (ev) => {
    const r = ev?.reason;
    pushCrashLog("unhandledrejection", {
      reasonType: typeof r,
      reason: safeToString(r),
      errorName: r?.name,
      errorMessage: r?.message,
      stack: r?.stack,
    });
  });
}

